import { AuthenticatedService } from "../abstract/base.service";
import { ListResponse } from "@/models/grids/list.response";
import { EntitiesEndpoint } from "./entities.service";
import { GetEntityFilesDtosQuery } from "@/server/app.queries";
import { EntityFileDto } from "@/server/app.dtos";

export class EntitiesFilesService extends AuthenticatedService {
  GetFiles(
    request: GetEntityFilesDtosQuery
  ): Promise<ListResponse<EntityFileDto>> {
    return this.Get<ListResponse<EntityFileDto>>(
      `${this.baseUrl}${EntitiesEndpoint}/${
        request.idEntity
      }/files?${this.GetQueryStringByObject(request)}`
    );
  }
}
